import React, { FC } from 'react';
import { Header } from '@components/molecules/Header';
import { Footer } from '@components/molecules/Footer';
import { GallerySection } from '@components/organisms/GallerySection/GallerySection';

interface AppContainerProps {
    children: string | JSX.Element;
    /** Elemento de banner CTA para ser renderizado antes do GallerySection */
    ctaBanner?: JSX.Element;
}

export const AppContainer: FC<AppContainerProps> = ({ children, ctaBanner }) => {
    return (
        <div className="page">
            <Header />
            <div className="align-items-center py-4 px-3" data-testid="app-container">
                {children}
            </div>
            {ctaBanner}
            <GallerySection />
            <Footer mode="normal" />
        </div>
    );
};
